// @flow

import React from "react";
import "./dropdown.style.scss";

type Props = $Exact<{
  children: React$Node,
  color?: string,
  className?: string,
  onClick?: Function,
  disabled?: boolean,
}>;

const DropDownItem = ({ children, color = "primary", className, ...props }: Props) => (
  <div className={`dropdown-item-wrapper  ${className || ""} text-${color}`} {...props}>
    {children}
  </div>
);

export default DropDownItem;
